import { BackendQueryKeys, useTypeSafeQuery } from '@oresundsbron/api';

type CountryCodeItem = {
  key: string;
};

export function useCountriesBvSupport() {
  const { data } = useTypeSafeQuery(
    BackendQueryKeys.CountryListBvSupported(),
    (req) => req.VehicleInfo.getBilvEnableCountries()
  );

  return data;
}
